import { Injectable, inject, DOCUMENT, computed } from "@angular/core";
import { NavigationStart, NavigationEnd, Router } from "@angular/router";
import { IRoutingSyncMessageType, isRoutingSyncEventFromParent, sendRoutingSyncToParent } from "./routing-sync-util";
import { fromEvent } from "rxjs";
import { filter } from "rxjs/operators";

/* istanbul ignore next */
@Injectable({
    providedIn: "root",
})
export class RoutingParentSyncService {
    private document = inject<Document>(DOCUMENT);
    private router = inject(Router);

    parentUrl!: URL;

    public readonly currentUrlPath = computed(() => {
        const nav = this.router.lastSuccessfulNavigation();
        return nav?.finalUrl?.toString() || this.router.url;
    });

    init(): void {
        if (window !== top) {
            this.parentUrl = new URL(this.document.referrer ? this.document.referrer : this.document.location.ancestorOrigins[0]);
            this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe((event) => {
                sendRoutingSyncToParent(window.parent, this.parentUrl.origin, event.urlAfterRedirects);
            });

            this.router.events.pipe(filter((event): event is NavigationStart => event instanceof NavigationStart)).subscribe((event) => {
                if (event.navigationTrigger === "popstate" && event.restoredState?.navigationId === -1) {
                    this.router.navigate([this.router.routerState?.snapshot?.url]);
                }
            });

            fromEvent(window, "message")
                .pipe(
                    filter((event): event is IRoutingSyncMessageType =>
                        isRoutingSyncEventFromParent(this.parentUrl.origin, event as MessageEvent<unknown>),
                    ),
                )
                .subscribe((event) => {
                    this.router.navigateByUrl(event.data.url, {
                        skipLocationChange: true,
                    });
                });
        }
    }
}
